/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListRepresentativesGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type ListRepresentativesRequest = {
  /**
   * ID of the account.
   */
  accountID: string;
};

export type ListRepresentativesResponse = {
  headers: { [k: string]: Array<string> };
  result: Array<components.Representative>;
};

/** @internal */
export const ListRepresentativesGlobals$inboundSchema: z.ZodType<
  ListRepresentativesGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type ListRepresentativesGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const ListRepresentativesGlobals$outboundSchema: z.ZodType<
  ListRepresentativesGlobals$Outbound,
  z.ZodTypeDef,
  ListRepresentativesGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function listRepresentativesGlobalsToJSON(
  listRepresentativesGlobals: ListRepresentativesGlobals,
): string {
  return JSON.stringify(
    ListRepresentativesGlobals$outboundSchema.parse(listRepresentativesGlobals),
  );
}
export function listRepresentativesGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<ListRepresentativesGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRepresentativesGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRepresentativesGlobals' from JSON`,
  );
}

/** @internal */
export const ListRepresentativesRequest$inboundSchema: z.ZodType<
  ListRepresentativesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
});
/** @internal */
export type ListRepresentativesRequest$Outbound = {
  accountID: string;
};

/** @internal */
export const ListRepresentativesRequest$outboundSchema: z.ZodType<
  ListRepresentativesRequest$Outbound,
  z.ZodTypeDef,
  ListRepresentativesRequest
> = z.object({
  accountID: z.string(),
});

export function listRepresentativesRequestToJSON(
  listRepresentativesRequest: ListRepresentativesRequest,
): string {
  return JSON.stringify(
    ListRepresentativesRequest$outboundSchema.parse(listRepresentativesRequest),
  );
}
export function listRepresentativesRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListRepresentativesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRepresentativesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRepresentativesRequest' from JSON`,
  );
}

/** @internal */
export const ListRepresentativesResponse$inboundSchema: z.ZodType<
  ListRepresentativesResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: z.array(components.Representative$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type ListRepresentativesResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: Array<components.Representative$Outbound>;
};

/** @internal */
export const ListRepresentativesResponse$outboundSchema: z.ZodType<
  ListRepresentativesResponse$Outbound,
  z.ZodTypeDef,
  ListRepresentativesResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: z.array(components.Representative$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function listRepresentativesResponseToJSON(
  listRepresentativesResponse: ListRepresentativesResponse,
): string {
  return JSON.stringify(
    ListRepresentativesResponse$outboundSchema.parse(
      listRepresentativesResponse,
    ),
  );
}
export function listRepresentativesResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListRepresentativesResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRepresentativesResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRepresentativesResponse' from JSON`,
  );
}
